module.exports = __webpack_public_path__ + "media/press/wsj-1ef20b3c.png";